import { Stack, Typography } from '@mui/material';
import { getUtilisationItemColour } from '../../utils/Utils';

enum MininumUtilisationThreshold {
  Low = 0,
  Ideal = 80,
  High = 101,
}

function UtilisationLegend() {
  const getFormattedLabel = (label: 'Low' | 'Ideal' | 'High') => {
    if (label === 'Low') {
      return `${label} : 0 - 79`;
    }
    if (label === 'Ideal') {
      return `${label} : 80 - 100`;
    }

    return `${label} : 101+`;
  };

  function getLegendItems() {
    return (
      Object.keys(MininumUtilisationThreshold).filter(x =>
        isNaN(Number(x))
      ) as (keyof typeof MininumUtilisationThreshold)[]
    ).map(key => {
      return generateLegendItem(getFormattedLabel(key), getUtilisationItemColour(MininumUtilisationThreshold[key]));
    });
  }

  const generateLegendItem = (status: string, stateColor: string) => {
    return (
      <Stack direction="row" alignItems={'center'} key={status}>
        <div
          style={{
            width: 15,
            height: 15,
            margin: 10,
            background: `linear-gradient(45deg, ${stateColor} 25%, #fff 25%, #fff 50%, ${stateColor} 50%, ${stateColor} 75%, #fff 75%, #fff 100%`,
            backgroundSize: `5px 5px`,
            backgroundColor: 'white',
          }}
        />
        <Typography fontWeight={'bold'} sx={{ color: stateColor }}>
          {status}
        </Typography>
      </Stack>
    );
  };

  return (
    <Stack sx={{ background: '#F0F0F0', padding: 0.5, borderRadius: 2 }}>
      <Typography variant="subtitle2" textAlign="center" color="#202020">
        Cumulative Utilisation (%)
      </Typography>
      <Stack direction="row" spacing={2}>
        {getLegendItems()}
      </Stack>
    </Stack>
  );
}

export default UtilisationLegend;
